module.exports = __webpack_public_path__ + "img/9788958076056.1408e941.jpg";